import React from 'react';
//import './About.css';
import IMAGES from "./Images";
import {Container} from "react-bootstrap";
function Ourwork() {
    return (
        <div className="text-start">
            <h1>Report</h1>
            <p>
                <strong>ARCHIDIOCESE DE BUJUMBURA Le 30, AO</strong>
                <strong>Û</strong>
                <strong>T 2021</strong>
                <strong></strong>
            </p>
            <p>
                <strong>PAROISSE ST. J. BAPTISTE</strong>
                <strong></strong>
            </p>
            <p>
                <strong>OASI MERE DE LA MISERICORDE DIVINE</strong>
                <strong></strong>
            </p>
            <p>
                <strong>GENERATION J. PAUL II</strong>
                <strong></strong>
            </p>
            <p>
                <strong>AU BURUNDI</strong>
                <strong></strong>
            </p>
            <p>
                <strong>REMERCIEMENT, EVALUATION ET NOUVELLES </strong>
                <strong></strong>
            </p>
            <p>
                Chers Bienfaiteurs et Bienfaitrices, nous sommes fières de notre apostolat
                qui est soutenu par Dieu à travers vos mains, prières, bonne volonté et
                sacrifice chrétien. Nous chantons la miséricorde de Dieu en le remerciant
                pour tout ce qu’Il nous a fait dans notre vie et encore de plus cette
                année-ci. Il vous a gardé aussi dans son amour et sa bonté, et nous les
                pauvres, nous avons profité de vous, les bienfaits spirituels et matériels
                que le Seigneur vous a comblé. Qu’il soit chanté et loué, à jamais ! Nous
                serions ingrats si nous ne formulons pas un grand remerciement élargi pour
                vous. Grand merci pour votre générosité exprimée par l’assistance envers
                ces orphelins nous les éducatrices. Nous le disons dans ces termes pauvres,
                mais ce que vous faites est riche du contenu. Car vous sauvez la vie.
            </p>
            <p>
                Nous sommes à la fin de l’année apostolique. Comme nous l’avons reçu en
                tant qu’héritage du Père fondateur : à la fin de l’année, nous nous mettons
                ensemble pour faire une évaluation sous la lumière de la retraite de huit
                jours. Comme rappel, cette année l’orphelinat était composé de 25 enfants
                internes et avec 2 sœurs bénévoles, et 6 sœurs éducatrices qui composent
                une communauté.
            </p>
            <p>
                <strong>I.1 EDUCATION CHRETIENNE </strong>
                <strong></strong>
            </p>
            <p>
                En général, les enfants ont bien évolué dans leur manière de prier (surtout
                les prières d’intentions) et de vivre les réalités chrétiennes. Nous voyons
                le changement dans leur vécu quotidien. En particulier, Au cours de cette
                année deux enfants ont eu le sacrement de communion.
            </p>
            <Container>
            <figure className="position-relative">
            <img src={IMAGES.ReportImage1} className="img-fluid" alt="First Image" style={{maxWidth:'24rem'}}/> 
            <figcaption>Le nouveau orphelin ici a quatre. Le fruit de la grossesse non-désirée. La deuxiènne grossesse non-désirée l’embryon  a été avorté. Ce qui fait que le coupable soit emprisonné et l’enfant s’est retrouvé dans la rue . </figcaption>
            </figure>
            </Container>
            <p>
                Ils ont bien suivi la catéchèse officielle de la paroisse et celle de
                l’orphelinat suivit par les activités pratiques. Selon ce que nous voyons
                d’eux, le sacrement les a aidé au niveau des relations interpersonnelles et
                la réduction de l’impulsivité.
            </p>
            <p>
                <strong>II. EDUCATION HUMAINE </strong>
                <strong></strong>
            </p>
            <p>
                Dans notre engagement il y a aussi la dimension de se faire tout pour que
                les enfants aient le niveau le plus élevés possible en morale et en
                sciences. Du fait que, nous avons un objectif de la vie intègre.
            </p>
            <p>
                En regardant de près ces enfants, du point de vue humain, l’esprit de
                l’agressivité est presque disparu. Car parmi eux, il y a ceux qui n’ont pas
                eu la chance d’avoir l’éducation de base de leurs parents. Mais cette
                année-ci, nous voyons des progrès surtout du point de vue sociale et la
                réappropriation de leur projet de vie, à travers les études. Le nombre de
                23 enfants a suivi l’école jusqu’à la fin de l’année. Un bon nombre de 16
                parmi eux, a bien réussi conformément aux exigences du ministère de
                l’éducation. Mais 7 ont échoué à cause de leurs manques d’aptitudes
                intellectuelles.
            </p>
            <p>
                <strong>III. ASPECT DE L</strong>
                <strong>’</strong>
                <strong>ECONOMIE DE L</strong>
                <strong>’</strong>
                <strong>ORPHELINAT</strong>
                <strong></strong>
            </p>
            <p>
                Nous vous remercions vivement d’avoir soutenir notre famille, vous êtes les
                témoins de la miséricorde divine. Vraiment c’est un bon motif, juste et
                vrai de chanter la miséricorde divine et ses merveilles. Pendant notre
                recueillement, nous avons contemplé cette beauté du Seigneur actualisée par
                votre sacrifice généreux, qui est solidaire et fraternel, de plus, plein de
                Chrétienté.
            </p>
            <p>
                Les dons que nous avons reçus ont été utilisés selon les exigences du
                fonctionnement de l’orphelinat. Et c’est à partir de vos supports que nous
                avons nourrit les enfants et essayé de maintenir quelques activités
                régénératrices de revenus. Par exemple : Elevage très modeste des cinq
                petits ruminants, location de la propriété pour la culture de maïs, du riz
                ainsi que les semences et les travaux d’entretien. Puis, l’ajout sur le
                capital de notre magasin. Nous avons acheté aussi une petite propriété pour
                augmenter le rendement même si nous n’avons encore tout payé. La raison qui
                nous a poussé à le faire ; est que sur le marché les produits alimentaires
                sont tellement chers. Mais avec notre propre production nous arrivons à
                gérer l’orphelinat. Les dons nous ont servis également dans les autres
                domaines suivants :
            </p>
            <p>
                Au cours de cette année-ci, nous sommes arrivées à maintenir le stock de la
                maison. Les enfants n’ont rien manqué sur le menu prévu. C’est grâce à vos
                mains ouvertes ! encore depuis le début de l’année scolaire les enfants ont
                eu tous les nécessaires pour l’école.
            </p>
            <p>
                Du point de vue spirituel, nous avons pu payer les outils des services
                liturgiques de nos chapelles, les demandes de la paroisse pour ceux qui ont
                reçu les sacrements. Nous avons trouvé aussi les moyens de deux retraites
                récentes. L’une des nouvelles et les bénévoles, l’autre de nous anciennes.
            </p>
            <p>
                Du point de vue de la santé, quatre enfants et cinq éducatrices sont tombés
                malades. Parmi les enfants. Un a été hospitalisé tandis que deux
                éducatrices ont été hospitalisées. Tous ont été bien soignés (...). Nous
                aurons les détails dans le rapport financier.
            </p>
            <p>
                <strong>IV. LES PREVISIONS POUR L</strong>
                <strong>’</strong>
                <strong>ANNEE APOSTOLIQUE QUI COMMENCE</strong>
                <strong></strong>
            </p>
            <p>
                Au cours de cette année apostolique qui s’annonce, nous nous préparons :
            </p>
            <p>
                1. D’accélérer dans les suivis des dossiers de l’école pour la réouverture
                et la construction de la maison des enfants à Nyambuye. Une fois réussit
                dans ces dossiers, nous continuons la construction.
            </p>
            <p>
                2. Etant donnée que nous avons de nous nouvelles éducatrices, nous nous
                efforcerons à servir nos pauvres pour qu’ils aient l’éducation chrétienne
                et humaine idoines selon notre charisme et la volonté de notre fondateur.
            </p>
            <p>
                3. Nous aurons besoin aussi d’un coup de main de la part des enseignants
                externes pour les cours du soir ainsi que l’inscription des enfants de
                l’école secondaire à l’institut culturel français en vue d’améliorer leurs
                capacités intellectuelles.
            </p>
            <p>
                4. Tout au début de ce mois de septembre, nous nous préparons pour le
                stock, les matériels scolaires. Apres, nous allons commençons les activités
                champêtres.
            </p>
            <p>
                5. Au niveau des activités régénératrices de revenus, nous tâcherons à
                continuer notre agriculture et élevage modeste afin d’avoir au moins la
                moitié de l’alimentation de qualité nutritive. C’est pourquoi si la
                providence nous était favorable nous finirions le payement de ladite
                propriété.
            </p>
            <p>
                6. Cette année nous avons quatre enfants qui recevrons les sacrements.
            </p>
            <p>
                <strong>Quelques nouvelles de la famille</strong>
                <strong></strong>
            </p>
            <Container>
            <figure classNameName="position-relative">
            <img src={IMAGES.ReportImage2} className="img-fluid" alt="First Image" style={{maxWidth:'24rem'}}/> 
            <figcaption>Le nouveau orphelin ici a quatre. Le fruit de la grossesse non-désirée. La deuxiènne grossesse non-désirée l’embryon  a été avorté. Ce qui fait que le coupable soit emprisonné et l’enfant s’est retrouvé dans la rue .</figcaption>
            </figure>
            </Container>
            <Container>
            <figure className="position-relative">
            <img src={IMAGES.ReportImage3} className="img-fluid" alt="First Image" style={{maxWidth:'24rem'}}/> 
            <figcaption>Le  motif en est que leur maman est devenu psychopathe et le Papa est incapable de sauver les enfants. Ils avaient abandonné l’école depuis. Puis, nous avons déjà trouvé les places à l’ école. </figcaption>
            </figure>
            </Container>
            <Container>
            <figure className="position-relative">
            <img src={IMAGES.ReportImage4} className="img-fluid" alt="First Image" style={{maxWidth:'24rem'}}/> 
            <figcaption> Dans ce mois d’août nous avons accueilli enfants en situation très graves</figcaption>
            </figure>
            </Container>
            <p>
                <strong>Celui-ci a été trouvé dans la rue, nous ne savons pas encore ni sa mère ni son Père, non plus sa parenté. Il ne parle pas mais pendant la nuit il pousse des cris et dort tardivement. La médecine ordinaire n’a rien confirmé jusqu’à présent.</strong>
                <strong></strong>
            </p>
            <Container>
            <figure className="position-relative">
            <img src={IMAGES.ReportImage5} className="img-fluid" alt="First Image" style={{maxWidth:'24rem'}}/> 
            <figcaption>Celui-ci a avait abandonné l’école à cause de la pauvre extrême de sa famille. Il gardait  le troupeau d’un riche sans lui payé l’argent sauf la nourriture. Il était en VIIème année.</figcaption>
            </figure>
            </Container>
            <Container>
            <figure className="position-relative">
            <figcaption>Ici en bas, il y a la génération que nous avons accompagné l’année passée qui habite orphelinat GIHOSHA Nyambuye. </figcaption>
            <img src={IMAGES.ReportImage6} className="img-fluid" alt="First Image" style={{maxWidth:'24rem'}}/>
            <img src={IMAGES.ReportImage7} className="img-fluid" alt="First Image" style={{maxWidth:'24rem'}}/>  
            </figure>
            </Container>

            <Container>
            <figure className="position-relative">
            <figcaption>Notre communautaire sera composée par douze éducatrices. Mais il y les deux absentes. </figcaption>
            <img src={IMAGES.ReportImage8} className="img-fluid" alt="First Image" style={{maxWidth:'24rem'}}/> 
            
            </figure>
            </Container>
            <p>
    Enfin, jusqu’à maintenant nous sommes en communications avec monseigneur
    vicaire General, notre constitution provisoire et la règle fondamentale
    rédigée et certifiée par le feu Père André RUNOBAGAZA sont chez lui. Nous
    attendons sa réponse. Nous vous demandons la prière d’intercession pour que
    les portes soient ouvertes pour. Nous mettons tous ces programmes entre les
    mains du Seigneur et nous mendions encore une fois votre âme généreuse.
</p>
<p>
    <strong><em>Que le Seigneur vous garde dans son amour et misé</em></strong>
    <strong><em>ricorde insondables</em></strong>
    <strong><em></em></strong>
</p>
<p>
    <strong><em> </em></strong>
    <strong><em>« Je chanterai à jamais la misé</em></strong>
    <strong><em>ricorde Dieu.</em></strong>
    <strong><em> »</em></strong>
    <strong><em> </em></strong>
    <strong><em></em></strong>
</p>
<p>
    Redigé par Emelyne NDAYIKENGURUKIYE
</p>
<p>
    Floride NDAYIPFUKAMIYE
</p>
        </div>
    );
}
export default Ourwork;

